module.exports = __webpack_public_path__ + "img/6.bc65f84d.webp";